export default {
	"route.dashboard": "Dashboard",
	"route.robot": "Robot",
	"route.robotList": "Robot lijst",
	"route.groupManage": "Groepsbeheer",
	"route.disinfect": "Taak",
	"route.home": "Startpagina",
	"route.disinfectTask": "Taak",
	"route.building": "Gebouw",
	"route.accessControl": "Toegangscontrole",
	"route.ladderControl": "Lift controle",
	"route.IOT": "IOT",
	"route.accounts": "Account",
	"route.roles": "Rol",
	"route.jurisdiction": "Toestemming",
	"route.dispatcher": "taakbeheerder",
	"navbar.logOut": "Uitloggen",
	"login.title": "Enterprise-ID inloggen",
	"login.logIn": "Log in",
	"login.username": "Gebruikersnaam",
	"login.tip_username": "Voer de gebruikersnaam in",
	"login.password": "Wachtwoord",
	"login.company_id": "Enterprise-ID",
	"login.tip_company": "Voer de ondernemings-ID in",
	"login.tip_pwd": "Vul alstublieft het wachtwoord in",
	"robot.projectTtitle": "Platform voor robotbeheer",
	"robot.manage": "Robotbeheer",
	"system.search": "Zoekopdracht",
	"system.reset": "Resetten",
	"system.open": "Ontvouwen",
	"system.retract": "Samenvouwen",
	"system.status": "status",
	"system.inProgress": "Bezig",
	"system.normalCompletion": "Voltooid",
	"system.abnormalEnd": "Abnormaal einde",
	"system.noData": "Geen gegevens",
	"universality.confirm": "Bevestigen",
	"universality.cancel": "Annuleren",
	"universality.Pleasedonot": "gelieve dit veld niet leeg laten",
	"universality.Pleaseifsymbols": "Voer 6-20 cijfers in, Engels, speciale symbolen",
	"disinfect.robotremarkname": "Robot bijnaam",
	"disinfect.EnterNoteName": "Voer de bijnaam in",
	"disinfect.robotSerialNumber": "Serienummer robot",
	"disinfect.inputSequenceNumber": "Serienummer invoeren",
	"disinfect.selectStatus": "Selecteer status",
	"disinfect.destination": "Bestemming",
	"disinfect.Enterdestination": "Bestemming invoeren",
	"disinfect.dates": "Datum",
	"disinfect.tos": "Tot",
	"disinfect.startDates": "Begin datum",
	"disinfect.endDates": "Einddatum",
	"disinfect.starttimes": "Starttijd",
	"disinfect.endtimes": "Eindtijd",
	"disinfect.Lastweek": "Vorige week",
	"disinfect.Lastmonth": "Vorige maand",
	"disinfect.Lastthreemonths": "Afgelopen 3 maanden",
	"disinfect.nonExecution": "Niet uitgevoerd",
	"disinfect.canceled": "Annuleren",
	"disinfect.UnclaimedProperty": "Niemand haalt de maaltijden op",
	"disinfect.hardwareFailure": "Hardwarestoring",
	"disinfect.NavigationFault": "Navigatie mislukt",
	"disinfect.Manualcancellation": "Handmatige annulering",
	"navigationBar.logout": "Uitloggen",
	"navigationBar.logoutandsystem": "Account en systeem uitloggen?",
	"account.userlist": "Gebruikers lijst",
	"account.searchnames": "Zoekopdracht",
	"account.adduser": "Voeg een gebruiker toe",
	"account.user": "Gebruiker",
	"account.roles": "Rol",
	"account.ResponsibleRobot": "robot in gebruik",
	"account.name": "Naam",
	"account.remark": "Opmerking",
	"account.Recentloginiof": "Laatste inloggegevens",
	"account.operation": "Operatie",
	"account.compile": "Bewerking",
	"account.resetpasswords": "Stel het wachtwoord opnieuw in",
	"account.delete": "Verwijderen",
	"account.pleaseuserpasnumb": "6-20 Engelse letters, cijfers, speciale tekens",
	"account.pleasepasswordnumb": "Voer het wachtwoord in (6-20 Engelse letters, cijfers, speciale tekens)",
	"account.selectroles": "Selecteer de rol",
	"account.selectbuild": "Selecteer het gebouw",
	"account.inputnames": "Voer de gebruikersnaam in",
	"account.inputremarks": "Gelieve opmerkingen in te voeren",
	"account.userdetail": "Gebruikersgegevens",
	"account.platform": "Eenheid",
	"account.noBindingRobot": "Geen robot gekoppeld",
	"account.addtimes": "Tijd toegevoegd",
	"account.LastonlineTime": "Laatste inlogtijd",
	"account.Resetsuccessfully": "Resetten succesvol",
	"account.initialPassword": "Origineel wachtwoord",
	"account.gotIt": "Begrepen",
	"account.PleaseRoles": "Selecteer de rol",
	"account.Pleasebuilds": "Selecteer het gebouw",
	"account.PleaseRobots": "Selecteer de robot",
	"account.compileusers": "wijzig account",
	"account.deleteusers": "Verwijder account",
	"account.Unabletologinafterdeleting": "Kan niet inloggen na het verwijderen van het account, gelieve te bevestigen",
	"account.alreadyexistsConfirmpasswords": "Het wachtwoord resetten naar het oorspronkelijke wachtwoord?",
	"account.alreadyExists": "Het account bestaat al",
	"map.deleteThecloudmap": "Als u de cloudkaart verwijdert, worden tegelijkertijd alle kaarten verwijderd die aan de robot zijn gekoppeld. Weet u zeker dat u dit wilt verwijderen?",
	"map.deletemaps": "Verwijder de kaart",
	"homes.robotTotal": "Totaal aantal robots",
	"homes.tasksTotal": "Totaal aantal cumulatieve taken",
	"homes.onlineTimeTotal": "Cumulatieve online tijd",
	"homes.nearly-7-days-onlineTime": "De trend van online tijd in de afgelopen 7 dagen",
	"homes.cumulativeMileage": "Cumulatieve kilometerstand (meter)",
	"homes.robotWorkingHoursData": "De gegevens van de werkuren van de robot",
	"homes.trendWorkingHours": "De trend van werkuren",
	"homes.explain": "Notities",
	"homes.explainContent": "Aflevergegevens van de robot in verschillende gebouwen",
	"homes.to": "Tot",
	"homes.startTime": "Starttijd",
	"homes.endTime": "Eindtijd",
	"homes.proportionWorkingHours": "Verhouding werkuren",
	"homes.buildingDeliveryList": "Ranglijst van levertijden in het pand",
	"public.second": "Keer",
	"public.rice": "Meter",
	"public.lastSevenDays": "Laatste 7 dagen",
	"public.lastFourteenDays": "Afgelopen 14 dagen",
	"public.lastThirtyDays": "Laatste 30 dagen",
	"robotState.notActive": "Niet geactiveerd",
	"robotState.abnormalEnd": "Abnormaal eind",
	"robotState.hasLeft": "Is vertrokken",
	"robotState.online": "Online",
	"robotState.offline": "offline",
	"robotState.charge": "opladen",
	"robotState.unknown": "Onbekend",
	"robotState.atWork": "Aan het werken",
	"robotState.free": "Vrij",
	"robotState.unexecuted": "Niet uitgevoerd",
	"robotState.executing": "Bezig",
	"robotState.canceled": "Geannuleerd",
	"robotState.Completed": "Voltooid",
	"robotState.nobodyTakesThings": "Niemand haalt de maaltijden op",
	"robot.robotList": "Robot lijst",
	"robot.buildings": "Gebouw",
	"robot.selectBuilding": "Selecteer het gebouw",
	"robot.search": "Zoek naar de bijnaam, het serienummer",
	"robot.notAddRobot": "Geen robot toegevoegd of geactiveerd",
	"robot.mileage": "Cumulatieve kilometerstand",
	"robot.information": "Basis informatie",
	"robot.noteName": "Bijnaam",
	"robot.model": "Model",
	"robot.onlineStatus": "Online status",
	"robot.workingStatus": "Werk status",
	"robot.currentPower": "Huidig vermogen",
	"robot.serialNumber": "Serienummer",
	"robot.operationData": "Operatie gegevens",
	"robot.latestOnlineTime": "Laatste keer online",
	"robot.cumulativeOnlineDuration": "Cumulatieve online tijd",
	"robot.cumulativeDeliveryTimes": "Cumulatieve levertijden",
	"robot.cumulative-delivery-time": "Cumulatieve levertijd",
	"robot.cumulativeLeadTimes": "Cumulatieve begeleidingstijden",
	"robot.cumulativeLeadTime": "Cumulatieve begeleidingstijd",
	"robot.System-Hardware": "Systeem en hardware",
	"robot.systemVersion": "Systeem versie",
	"robot.hardwareStatus": "Hardwarestatus",
	"robot.language": "Systeem taal",
	"robot.voice_pack": "Stem pakket",
	"robot.box_model": "vak",
	"robot.android_soft": "Android-software",
	"robot.android_mirror": "Android-ROM",
	"robot.header_control": "Hoofd controlebord",
	"robot.under_panel_version": "Chassisversie",
	"robot.under_mirror": "Chassis-ROM",
	"robot.under_master": "Chassis hoofdbediening",
	"robot.under_control": "Chassis-besturingskaart",
	"robot.rgbd_up": "RGBD(omhoog)",
	"robot.rgbd_down": "RGBD(omlaag)",
	"robot.doorControlMotor": "Motor voor deurbediening",
	"robot.frontMountedCamera": "Voor camera",
	"robot.overheadCamera": "Topcamera",
	"robot.infraredDetectionBox": "Infrarood detectie",
	"robot.microphone": "Microfoon",
	"robot.radar": "Lidar",
	"robot.head-RGBD": "Hoofd RGBD",
	"robot.bottom-RGBD": "Onder RGBD",
	"robot.ultrasonicSensor": "Ultrasoon sensor",
	"robot.IMU": "IMU",
	"robot.hubMotor": "Hub motor",
	"robot.emergencyStopSwitch": "Noodstop knop",
	"robot.horn": "Spreker",
	"robot.getFailed": "Mislukt",
	"robot.normal": "Normaal",
	"robot.abnormal": "Abnormaal",
	"robot.cancel": "Verwijderen",
	"robot.confirm": "Bevestigen",
	"public.noteNameCannotBeEmpty": "de bijnaam mag niet leeg zijn",
	"public.layer": "Verdieping",
	"public.door": "Gebouw",
	"public.rename": "Hernoemen",
	"public.delete": "Verwijderen",
	"robot.percentageTasksCompletedTotal": "Het percentage voltooide cumulatieve taken",
	"robotState.workSuspension": "Taak gestopt",
	"buiding.buildingList": "Gebouw lijst",
	"buiding.add": "Toevoegen",
	"buiding.addFloors": "Voeg een verdieping toe",
	"buiding.pleaseCompleteBuidingsData": "Vul de gebouwgegevens in de lijst aan de linkerkant in!",
	"buiding.map": "Kaart",
	"buiding.source": "Bron",
	"buiding.uploadTime": "Upload tijd",
	"buiding.pleaseRobotUploadMap": "Upload de kaart naar de robot",
	"buiding.associatedBuildings": "Bijbehorende gebouwen",
	"buiding.robot": "Robot",
	"buiding.associatedRobot": "Bijbehorende robots",
	"buiding.associatedShop": "Bijbehorende winkels",
	"buiding.type": "Type",
	"buiding.pleaseType": "Selecteer het type",
	"buiding.buildingName": "Naam van het gebouw",
	"buiding.pleaseBuildingName": "Voer de naam van het gebouw in",
	"buiding.shopName": "Winkel naam",
	"buiding.pleaseShopName": "Voer de winkelnaam in",
	"buiding.floor": "Verdieping",
	"buiding.floorName": "Verdieping naam",
	"buiding.pleaseFloorName": "Verdieping naam",
	"buiding.floorNameBeEmpty": "De naam van de verdieping mag niet leeg zijn",
	"buiding.buid": "Gebouw",
	"buiding.shop": "Winkel",
	"buiding.serialNumberCannotBeEmpty": "Het serienummer mag niet leeg zijn",
	"buiding.buildingAdd": "Voeg een gebouw toe",
	"buiding.pleaseBuilsdingName": "Voeg de naam van het gebouw toe",
	"buiding.buildingsNameBeEmpty": "De naam van het gebouw mag niet leeg zijn",
	"buiding.AreYouSureToDeleteThisFloor": "Weet u zeker dat u de verdieping wilt verwijderen?",
	"buiding.deleteFloor": "Verwijder de verdieping",
	"buiding.AreYouSureToDeleteThisShop": "Weet u zeker dat u de \"winkel\" wilt verwijderen?",
	"buiding.deleteShop": "Verwijder de winkel",
	"buiding.AreYouSureToDeleteThisBuilding": "Weet u zeker dat u het \"gebouw\" wilt verwijderen?",
	"buiding.deleteBuilding": "Verwijder het gebouw",
	"buiding.editBuilding": "Bewerk het gebouw",
	"buiding.editFloor": "Bewerk de verdieping",
	"buiding.editShop": "Bewerk de winkel",
	"buiding.shopNameAlreadyExists": "De winkelnaam bestaat al",
	"buiding.shopAddSuccess": "De winkel is succesvol toegevoegd",
	"buiding.floorNameAlreadyExists": "De naam van de verdieping bestaat al",
	"buiding.floorAddSuccess": "De verdieping is succesvol toegevoegd",
	"buiding.buildingNameAlreadyExists": "De naam van het gebouw bestaat al",
	"buiding.buildingAddSuccess": "Het gebouw is succesvol toegevoegd",
	"buiding.shopEditSuccess": "De winkel is succesvol bewerkt",
	"buiding.buildingEditSuccess": "Het gebouw is succesvol bewerkt",
	"buiding.floorEditSuccess": "De verdieping is succesvol bewerkt",
	"buiding.selectRobot": "Selecteer een robot",
	"buiding.replacementBuildings": "Verander naar een ander gebouw",
	"role.rolelist": "Rollen overzicht",
	"role.addroles": "Voeg een rol toe",
	"role.names": "Naam",
	"role.Entername": "Voer een naam in",
	"role.PleaseEntername": "Voer een naam in",
	"role.editroles": "Bewerk de rol",
	"role.deleteroles": "Verwijder de rol",
	"role.Confirmdeletion": "Weet u zeker dat u de \"rol\" wilt verwijderen? U kunt deze actie niet ongedaan maken.",
	"role.nameAlreadyExists": "De rol bestaat al",
	"navigationBar.personalInfo": "Persoonlijke informatie",
	"navigationBar.changePassword": "Verander wachtwoord",
	"navigationBar.administrator": "Beheerder",
	"navigationBar.domesticConsumer": "Algemene gebruiker",
	"navigationBar.originalPsd": "Origineel wachtwoord",
	"navigationBar.EnterOriginalPsd": "Voer het oorspronkelijke wachtwoord in",
	"navigationBar.newPassword": "Nieuw paswoord",
	"navigationBar.confirmPassword": "Bevestig het wachtwoord",
	"navigationBar.EntertheNewPsdAga": "Voer het nieuwe wachtwoord opnieuw in",
	"navigationBar.TheOriPsdCannotEmpty": "Het oorspronkelijke wachtwoord mag niet leeg zijn",
	"navigationBar.TheNewPsdempty": "Het nieuwe wachtwoord mag niet leeg zijn",
	"navigationBar.PleEntertheNewPsdAga": "Voer het nieuwe wachtwoord opnieuw in",
	"navigationBar.TheNewPasastheoldone": "Het nieuwe wachtwoord is hetzelfde als het oude wachtwoord",
	"navigationBar.Psdisinconsistentwith": "De twee wachtwoorden zijn verschillend. Bevestig alstublieft.",
	"navigationBar.modifySuccessfully": "Succesvol gewijzigd",
	"accessControl.accessControlList": "Toegangscontrole lijst",
	"accessControl.floor": "Verdieping",
	"accessControl.accessControlAdd": "Voeg de toegangscontrole toe",
	"accessControl.accessControlID": "Toegangscontrole-ID",
	"accessControl.selectAccessControlID": "Selecteer de toegangscontrole-ID",
	"accessControl.accessControlID-Hint": "Toegangscontroleservice is bevestigd. De klant heeft de toegangscontrole-ID al geconfigureerd.",
	"accessControl.label": "bijnaam",
	"accessControl.pleaseLabel": "Voer de bijnaam in",
	"accessControl.deleteAccessControl-Hint": "Als u de toegangscontrole verwijdert, kan de robot niet meer automatische deurtaken uitvoeren. Weet u zeker dat u het wilt verwijderen?",
	"accessControl.deleteAccessControl": "Verwijder de toegangscontrole",
	"accessControl.editAccessControl": "Bewerk de toegangscontrole",
	"accessControl.accessControlIdExists": "Toegangscontrole-ID bestaat al",
	"public.notAssociatedFloor": "Niet gekoppeld aan een verdieping",
	"public.notAssociatedBuilding": "Niet gekoppeld aan een gebouw",
	"public.all": "Alle",
	"public.rules.pleaseLabel": "Voer de bijnaam in",
	"dispatcher.dispatcherList": "taakbeheerder lijst",
	"dispatcher.searchName": "Zoek de naam",
	"buiding.deleteShopTips": "Ontkoppel eerst alle gegevens (robots/kaarten) van de winkel",
	"buiding.deleteBuidingTips": "Ontkoppel eerst alle gegevens (robots/kaarten) van het gebouw",
	"buiding.deleteFloorTips": "Ontkoppel eerst alle gegevens (plattegronden) van de verdieping",
	"ladderControl.ladderControlList": "Controlelijst lift",
	"ladderControl.addLadderControl": "Voeg een liftcontrole toe",
	"ladderControl.grouping": "Groepering",
	"ladderControl.Buildings": "Gebouw",
	"ladderControl.You-can-go-to-the-floor": "Toegankelijke verdiepingen",
	"ladderControl.pleaseGoToBuilding": "Ga naar het gebouw en krijg toegang tot de liftbediening",
	"ladderControl.grouping-tips-1": "Groepering wordt voornamelijk gebruikt om verschillende brandmelders te onderscheiden",
	"ladderControl.grouping-tips-2": "1. Voor de situatie van slechts één lift of meerdere liften op dezelfde verdieping kunt u de standaardgroep selecteren",
	"ladderControl.grouping-tips-3": "2. Liften op verschillende verdiepingen en wachtruimten dienen in groepen verdeeld te worden",
	"public.common": "Gebouw",
	"ladderControl.ladderControlID": "Liftcontrole-ID",
	"ladderControl.selectLadderControlID": "Selecteer liftcontrole-ID",
	"ladderControl.ladderControlID-tips": "Controleer bij de liftcontrole-/toegangscontroleservice of de klant de liftcontrole-ID al heeft geconfigureerd",
	"ladderControl.groupingPlaceholder": "Voer een groep in of selecteer deze (bijv.: hoogbouwliften)",
	"ladderControl.deleteladderControl": "liftcontrole verwijderen",
	"ladderControl.deleteladderControl-tips": "Als u de liftcontrole verwijdert, kan de robot geen taken over meerdere verdiepingen uitvoeren. Weet u zeker dat u het wilt verwijderen?",
	"ladderControl.ladderControlIdExists": "De liftcontrole-ID bestaat al",
	"login.remTheNub": "Onthoud het wachtwoord",
	"login.oldPasswordError": "Het oude wachtwoord is verkeerd",
	"login.confirmAndNewParrword": "De twee wachtwoorden zijn niet hetzelfde",
	"robot.advertising": "Advertenties",
	"homes.buildingDeliveryTimes": "Levertijden",
	"robot.detail": "Robotgegevens",
	"robot.robotModel": "Robottype",
	"robot.header_control-2": "Android-voedings module",
	"robot.under_mirror-2": "Chassis-ROM",
	"robot.under_master-2": "Chassis hoofdbesturing",
	"robot.under_control-2": "Chassis voedingsmodule",
	"robot.nav": "Navigatie algoritme",
	"robot.up_rgbd": "Boven RGBD",
	"robot.down_rgbd": "Onder RGBD",
	"robot.camera": "Topcamera",
	"robot.ss": "Voor camera",
	"robot.rgbd_top_depth": "Top RGBD-diepte",
	"robot.rgbd_top_color": "Top RGBD-kleur",
	"robot.rgbd_bottom_depth": "Onder RGBD-diepte",
	"robot.rgbd_bottom_color": "Onder RGBD-kleur",
	"robot.ultrasonic1": "Linker echografie",
	"robot.ultrasonic2": "Rechter echografie",
	"robot.motor1": "Linkermotor",
	"robot.motor2": "Rechtermotor",
	"robot.detection": "Objectdetectie",
	"buiding.builNameAlreadyExists": "De naam van het gebouw bestaat al",
	"robot.bindingSuccess": "Succesvol gekoppeld",
	"robot.notActive": "Niet geactiveerd",
	"robotinfo.logdown": "Log downloaden",
	"robotinfo.Logtype": "Logtype",
	"robotinfo.displayboard": "Displayscherm",
	"robotinfo.maincontrolpanel": "Hoofdcontrolebord",
	"robotinfo.powerstrip": "Power Board",
	"robotinfo.navigationdata": "Navigatie gegevens",
	"robotinfo.Plethedate": "Selecteer een datum",
	"robotinfo.Plethetime": "Selecteer een tijd",
	"robotinfo.acquire": "Downloaden",
	"robotinfo.Packinglog": "Logbestanden samenvoegen",
	"robotinfo.Uploadinglogfiles": "Logbestanden uploaden",
	"robotinfo.Gettinguploadstatus": "Uploadstatus ophalen",
	"robotinfo.acquiresuccess": "Verkrijgen succesvol",
	"robotinfo.clicktodownload": "Klik om te downloaden",
	"robotinfo.Plelogtype": "Selecteer een logboektype",
	"robotinfo.Plestartdateandtime": "Selecteer een startdatum en -tijd",
	"robotinfo.Pleanenddateandtime": "Selecteer een einddatum en -tijd",
	"robotinfo.Nologtime": "Geen logboeken voor deze periode",
	"robotinfo.logtaskispackagedpackged": "De robot is momenteel logboeken aan het samenvoegen of uploaden",
	"robotinfo.failtoget": "Verkrijgen mislukt",
	"robotinfo.Failedtopackage1/2": "Samenvoegen mislukt 1/2",
	"robotinfo.Failedtopackage2/2": "Samenvoegen mislukt 2/2",
	"robotinfo.failtoupload": "Upload mislukt",
	"public.unrelatedBuildings": "Niet-geassocieerd gebouw",
	"buiding.sameFloorNumber": "Hetzelfde verdiepingsnummer bestaat al in dit gebouw",
	"navigationBar.pleaseEnterOriginalPsd": "Voer het oorspronkelijke wachtwoord in",
	"navigationBar.newpassword": "Voer een nieuw wachtwoord in (voer 6-20 cijfers in, Engels, symbolen)",
	"navigationBar.pleaseNewpassword": "Voer een nieuw wachtwoord in",
	"login.nnterprise-number-error": "Enterprise ID-fout",
	"home.Fullrobot": "Alle robots",
	"map.displaytext": "tekst weergave",
	"map.nonetext": "Geen tekst weergeven.",
	"robot.detection-1": "Objectdetectie 1",
	"robot.detection-2": "Objectdetectie 2",
	"robot.detection-3": "Objectdetectie 3",
	"robot.detection-4": "Objectdetectie 4",
	"robot.current_systemVersion": "Huidige versie",
	"robot.cumulativeTimes": "aantal bezorgde maaltijden",
	"robot.cumulativeTime": "Cumulatieve bezorgtijd",
	"home.hour": "H",
	"home.min": "min",
	"home.deliverytimes": "bezorgen (aantal keer)",
	"login.actpaswdinco": "foute gebruikersnaam of wachtwoord",
	"login.enterpriseerror": "Enterprise ID-fout",
	"home.numberofworkmachs": "Aantal werkende robots",
	"home.workinghours": "Werkuren",
	"login.account_expired": "Account is verlopen, log opnieuw in",
	"robot.CADEBOT_rankingList_tips": "Bestemmingen leveringsranglijst",
	"robot.setLabel": "bijnaam instellen succesvol",
	"homes.nearly-7-days-mileage": "Kilometerstand in de afgelopen 7 dagen",
	"robot.robotisofflineobtalogs": "Robot is offline, kan geen logboeken ophalen",
	"buiding.buid-illustrate": "Gebouw (voor meerdere verdiepingen)",
	"buiding.shop-illustrate": "Winkel (voor één verdieping)",
	"buiding.new-pleaseFloorName": "Voer de naam van de verdieping in",
	"route.admage": "Ads",
	"route.asset": "Materiaalbibliotheek",
	"route.ads": "Advertentie vrijgeven",
	"route.adsDetail": "Advertentie details",
	"route.addAds": "Advertentie toevoegen",
	"route.editAds": "Advertentie bewerken",
	"ad.asset": "Bronnen Lijst",
	"ad.freeSpace": "Beschikbare ruimte",
	"ad.uploadAsset": "Bronnen uploaden",
	"ad.filename": "Naam bestand",
	"ad.type": "Type",
	"ad.memory": "Geheugen",
	"ad.video": "Video",
	"ad.image": "Afbeelding",
	"ad.uploadTime": "Uploadtijd",
	"ad.uploadProgress": "Upload voortgang",
	"ad.uploadSuccess": "Upload succesvol",
	"ad.operation": "Werking",
	"ad.check": "Bekijk",
	"ad.delete": "Verwijderen",
	"ad.confirm": "Bevestigen",
	"ad.cancel": "Annuleren",
	"ad.deleteSuccess": "Met succes verwijderd",
	"ad.back": "Terug",
	"ad.deleteAsset": "Hulpbronnen verwijderen",
	"ad.deleteAssetWarningMessage": "Verwijderde resources worden niet hersteld, bevestig verwijdering?",
	"ad.extLimit": "Alleen bestanden in de indelingen JPG, PNG, MP4, AVI, MOV, WMV, RMVB kunnen worden geüpload.",
	"ad.sizeLimit": "Een bestand mag niet groter zijn dan 1GB",
	"ad.syncFail": "download mislukt",
	"ad.syncComplete": "download compleet",
	"ad.downloadComplete": "Configuratie bezig",
	"ad.downloadWaiting": "Niet gedownload",
	"ad.name": "Naam",
	"ad.playTime": "afspeeltijd",
	"ad.materialNum": "Aantal hulpmiddelen",
	"ad.robotNum": "Aantal gegoten robots",
	"ad.startTime": "Tijd publiceren",
	"ad.addSchema": "Advertentie toevoegen",
	"ad.copySchema": "Kopieer plan",
	"ad.edit": "Bewerking",
	"ad.publish": "Publiceer",
	"ad.deleteDraft": "Plan verwijderen",
	"ad.save": "Opslaan",
	"ad.preview": "Voorbeeld",
	"ad.setDefault": "Nu gebruiken",
	"ad.setDefaultPlease": "Stel in als standaard",
	"ad.yes": "Ja",
	"ad.no": "Nee",
	"ad.deleteDraftWarningMessage": "Bevestig verwijderen van het programma?",
	"ad.draft": "Niet gepubliceerd",
	"ad.schemaDetail": "Details plan",
	"ad.schemaContent": "Inhoud plan",
	"ad.syncRecord": "Gesynchroniseerde opname",
	"ad.robotSn": "Robots verwijderen",
	"ad.robotSelect": "Selecteer robot",
	"ad.nameInput": "Voer de naam van het plan in",
	"ad.robotSelectPlease": "Selecteer robot",
	"ad.nameInputPlease": "Voer een plan naam in",
	"ad.materialList": "Bronnenlijst",
	"ad.materialListDescriptions": "Afmeting Advertentiescherm: 1080*1920. Sleep de kaarten om de volgorde aan te passen.",
	"ad.setting": "Plaatsingsinstellingen",
	"ad.period": "Tijdsperiode",
	"ad.allDay": "Hele dag",
	"ad.someTime": "Tijdsperiode",
	"ad.beginTime": "Starttijd",
	"ad.endTime": "Eindtijd",
	"ad.materialLib": "Bibliotheek Hulpmiddelen",
	"ad.materialNumber": "Aantal bronnen",
	"ad.removeScreen": "Gesplitst scherm verwijderen",
	"ad.removeScreenConfirm": "Bevestigen om gesplitst scherm te verwijderen?",
	"ad.playTimeDuration": "Afspeelduur",
	"ad.picturePlayTime": "Afspeelduur afbeelding",
	"ad.addPeriod": "Tijdslot toevoegen",
	"ad.addPeriodLimit": "Je kunt 6 verschillende tijdsloten toevoegen",
	"ad.totalTime": "Totale duur",
	"ad.saveSuccess": "Succesvol opslaan",
	"ad.publishSuccess": "Succesvol publiceren",
	"ad.addPeriodFail": "Er is al een tijdslot voor een hele dag, kan niet worden toegevoegd",
	"ad.publishFail": "Publiceren mislukt",
	"ad.playTimeNoEmpty": "Speeltijd kan niet leeg zijn",
	"ad.materialListNoEmpty": "Splitscreen kan niet leeg blijven",
	"ad.robot": "Robot",
	"ad.robotOffline": "Robot offline",
	"ad.robotOfflineAndCanNotLaunch": "De volgende robots zijn offline en kunnen niet geplaatst worden",
	"ad.robotUplineOrSaveDraft": "Bedien de robot online of sla het plan eerst op als concept.",
	"ad.syncStatus": "Downloadstatus robot",
	"ad.reSync": "Opnieuw publiceren",
	"ad.goBackList": "Terug naar de lijst",
	"ad.confirmPublish": "Weet je zeker dat je wilt publiceren?",
	"ad.robotOfflineToConfirmPublish": "De volgende robot is offline, kunt u het publiceren bevestigen?",
	"ad.addCancelConfirm": "Wilt u bevestigen dat de huidige inhoud niet wordt opgeslagen na terugkeer?",
	"ad.refresh": "Vernieuw",
	"ad.publishTime": "Tijd publiceren",
	"ad.lastModifyTime": "Tijd laatste wijziging",
	"ad.publisher": "Gepubliceerd door",
	"ad.editor": "Gewijzigd door",
	"ad.timeOverlap": "Afspeelperioden kunnen elkaar niet overlappen, controleer",
	"ad.endTimeMustLargerThanStartTime": "De eindtijd van de afspeelperiode moet groter zijn dan de starttijd",
	"ad.cannotDeleteAssetUsed": "Er is verwezen naar dit fragment en het kan niet worden verwijderd.",
	"ad.deletePeriodWarningMessage": "Wilt u het verwijderen van tijdvakken bevestigen?",
	"ad.complete": "Gereed",
	"ad.fail": "Mislukt",
	"ad.nameInputIllegal": "De naam van het plan mag geen speciale tekens bevatten",
	"ad.nameDuplicate": "De plannaam bestaat al",
	"ad.updateTime": "Laatste wijzigingstijd",
	"role.TherolesDeletingfails": "De rol is gebonden aan een account, verwijderen mislukt",
	"account.Changeofauthority": "Wijziging toestemming",
	"account.ThepermisschgePleaseagain": "De rechten van deze account zijn gewijzigd",
	"disinfect.Unknowncause": "Geen reden bekend",
	"robot.accumulatedTaskExecutionTimes": "Cumulatief aantal uitgevoerde taken",
	"home.minute": "minuten",
	"homes.Statisticstasks": "Statistieken van de robot die taken uitvoert (werk in uitvoering)",
	"disinfect.Initilizati": "Initialisatie mislukt",
	"disinfect.Failedtogetlocation": "het ophalen van locatie mislukt",
	"disinfect.pointisoffthemap": "Het doelpositie bevindt zich buiten de kaart",
	"disinfect.onastaticobstacle": "Het doelpositie bevindt zich op een statisch obstakel",
	"disinfect.therearenoroadsonthestaticmap": "Er zijn geen wegen op de statische kaart",
	"disinfect.Startingpointobstacle": "Obstakel op de startpositie",
	"disinfect.Lossoflocation": "Locatie verloren",
	"disinfect.Failedtolocatethelostlocalpath": "Gedeeltelijke routeplanning mislukt",
	"disinfect.Clifftriggercancellation": "Annulering vanwege klifdetectie",
	"disinfect.Emergencystoptriggerscancellation": "Annulering vanwege noodstop",
	"disinfect.Collisionbartriggercancel": "Annulering vanwege botsbeveiliging",
	"disinfect.overtime": "Time-out",
	"disinfect.Chargingpiledetectionfailed": "Detectie oplaadstation mislukt",
	"disinfect.Pilefailure": "koppelen oplaadstation mislukt",
	"disinfect.GlobalpathplanningfailedProcedure": "Volledige routeplanning mislukt",
	"disinfect.Slopetriggercancellation": "Annulering vanwege hellingdetectie",
	"disinfect.NavigationrecoverybeProcedure": "Navigatieherstel mislukt",
	"disinfect.Navigateoutnarrowchannel": "Smal pad is geblokkeerd",
	"disinfect.Androidtasktimeout": "Taak time-out",
	"disinfect.elsesa": "Andere fouten",
	"robot.historicaldelete": "De historische gegevens van deze robot worden verwijderd, bevestig verwijdering?",
	"robot.delfaild": "Verwijdering mislukt",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "Gekoppelde SIM-kaart",
	"robot.accumulatedUsageTraffic": "Cumulatief verkeersgebruik",
	"robot.trafficUsageMonth": "Maandelijks verkeersgebruik",
	"robot.newrgbd_bottom_depth": "Onder RGBD-diepte",
	"robot.batteryTest": "Batterijdetectie",
	"robot.Partial_information_update_failed": "Kan bepaalde informatie niet bijwerken",
	"robot.update_failed": "update mislukt",
	"robot.update_robot_datasSuccess": "Ontvang de laatste gegevens van de robot met succes",
	"ad.waitForDownload": "wachten om te downloaden",
	"ad.startDownload": "start download",
	"ad.offLineAndCannotDownload": "Apparaat offline, kan niet downloaden",
	"ad.syncing": "synchroniseren...",
	"robot.robot_does_not_exist": "robot bestaat niet",
	"robot.robot_current_enterprise": "Robots hebben de huidige onderneming verlaten",
	"ad.notEnoughSpace": "Er is onvoldoende ruimte voor bedrijfsmateriaal, ruim de bestanden op tijd op",
	"ad.addAsset": "materiaal toevoegen",
	"robot.batteryCommunication": "batterij communicatie",
	"disinfect.Thetargetpointisobstacle": "Het doelpunt bevindt zich op een dynamisch obstakel",
	"disinfect.Therearenoroadsonadynamicmap": "Er is geen weg op de dynamische kaart",
	"robot.buildingRobotErrorTips_10019": "Het aantal robots in deze winkel heeft de bovengrens van 16 bereikt, verander het gebouw (winkel)",
	"robot.buildingRobotErrorTips_10020": "Fout bij het genereren van LoraId",
	"map.VirtualWall": "Virtuele muur",
	"map.tracks": "Pad",
	"map.Qrcode": "QR code",
	"map.regions": "Gebied",
	"map.anchorpoints": "Positie punt",
	"robot.noSearchResults": "geen resultaten gevonden",
	"robot.accountInformationHasBeenModified": "Accountgegevens zijn aangepast",
	"public.tips": "wskazówka",
	"public.agreeWith": "mee eens zijn",
	"public.iHaveReadAndAgree": "Ik heb gelezen en ga akkoord",
	"public.userAgreement": "Accord de l'utilisateur",
	"public.gentle": "I",
	"public.privacyAgreement": "Privacybeleid",
	"public.pleaseAgreeFirst": "gelieve eerst akkoord te gaan",
}